export const SPINNER = "SPINNER";
export const spinnerAction = (data) => {
    return {
        type: SPINNER,
        payload:data
    }
}